/** Converts a css-styled entry like `"0.75rem"` to a px number, e.g. `12` */
export var rem2pixelNumber = function (floatRem) {
    return parseFloat(floatRem) *
        parseFloat(getComputedStyle(document.documentElement).fontSize);
};
//# sourceMappingURL=rem2pixels.js.map